import { Layout } from 'antd'
import { Content } from 'antd/es/layout/layout'
import React from 'react'

const Loading = () => {
  return (
      <Layout >
          <Content>
              <div style={{
                  overflowX: 'auto', width: '100%', backgroundColor: "white",
                  height: "80vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: 'center',
                  fontSize:"30px"}}>
                  
                  Loading...
                  </div>
          </Content>
          </Layout>
  )
}

export default Loading